import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhaseTwo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 273,
	height: 182,
	viewBox: "0 0 273 182",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "bg",
			d: "M48 97.9467C48 108.426 56.9265 133.452 76.2357 144.46C95.9518 155.7 112.482 146.296 135.732 146.666C153.294 146.947 164.116 151.918 180.708 146.666C204.185 139.236 229.656 126.497 224.272 104.381C220.527 89.0014 202.694 89.2511 191.599 77.1719C180.531 65.122 181.718 52.6816 168.002 43.16C138.311 22.5489 102.101 37.9923 74.4206 60.8094C60.3555 72.4031 48 87.4673 48 97.9467Z",
			fill: "#031A6B",
			fillOpacity: .02
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 159.993,
			cy: 114.201,
			rx: 27.5844,
			ry: 27.0573,
			stroke: "#CAD0E1",
			strokeWidth: .5625,
			strokeLinecap: "round",
			strokeDasharray: "1.5 2.25"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 89.3766,
			cy: 98.8917,
			rx: 27.5844,
			ry: 27.0573,
			stroke: "#CAD0E1",
			strokeWidth: .5625,
			strokeLinecap: "round",
			strokeDasharray: "1.5 2.25"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 201.767,
			y1: 126.387,
			x2: 201.767,
			y2: 127.341,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 201.767,
			y1: 128.159,
			x2: 201.767,
			y2: 129.112,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 200.413,
			y1: 127.784,
			x2: 201.392,
			y2: 127.784,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 202.219,
			y1: 127.784,
			x2: 203.198,
			y2: 127.784,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 203.801,
			cy: 111.065,
			rx: 11.7489,
			ry: 11.0234,
			stroke: "#CAD0E1",
			strokeWidth: .5625,
			strokeLinecap: "round",
			strokeDasharray: "1.5 2.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.7443 68.5421C94.7443 69.169 94.2252 69.6833 93.5772 69.6833C92.9293 69.6833 92.4102 69.169 92.4102 68.5421C92.4102 67.9152 92.9293 67.4009 93.5772 67.4009C94.2252 67.4009 94.7443 67.9152 94.7443 68.5421Z",
			stroke: "#CAD0E1",
			strokeWidth: .375
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M157.794 44.6026C157.794 45.2295 157.275 45.7438 156.627 45.7438C155.979 45.7438 155.46 45.2295 155.46 44.6026C155.46 43.9758 155.979 43.4614 156.627 43.4614C157.275 43.4614 157.794 43.9758 157.794 44.6026Z",
			stroke: "#CAD0E1",
			strokeWidth: .375
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M170.601 97.3308C170.601 97.9577 170.082 98.472 169.434 98.472C168.786 98.472 168.267 97.9577 168.267 97.3308C168.267 96.7039 168.786 96.1896 169.434 96.1896C170.082 96.1896 170.601 96.7039 170.601 97.3308Z",
			stroke: "#CAD0E1",
			strokeWidth: .375
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.3853 111.87C85.3853 112.497 84.8662 113.011 84.2182 113.011C83.5702 113.011 83.0511 112.497 83.0511 111.87C83.0511 111.243 83.5702 110.729 84.2182 110.729C84.8662 110.729 85.3853 111.243 85.3853 111.87Z",
			stroke: "#CAD0E1",
			strokeWidth: .375
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 172.523,
			y1: 71.6461,
			x2: 172.523,
			y2: 72.5998,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 172.523,
			y1: 73.4177,
			x2: 172.523,
			y2: 74.3714,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 171.168,
			y1: 73.0427,
			x2: 172.148,
			y2: 73.0427,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 172.974,
			y1: 73.0427,
			x2: 173.954,
			y2: 73.0427,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 161.576,
			y1: 127.188,
			x2: 161.576,
			y2: 128.141,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 161.576,
			y1: 128.959,
			x2: 161.576,
			y2: 129.913,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 160.221,
			y1: 128.584,
			x2: 161.201,
			y2: 128.584,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 162.028,
			y1: 128.584,
			x2: 163.007,
			y2: 128.584,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .506339,
			y: .170843,
			width: 19.5424,
			height: 10.6458,
			rx: .375,
			transform: "matrix(0.89944 -0.437044 0.450797 0.892627 121.149 53.8854)",
			stroke: "#CAD0E1",
			strokeWidth: .75
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M133.872 53.7949L143.707 54.708C143.914 54.7273 144.097 54.5768 144.114 54.3718C144.132 54.1669 143.978 53.9851 143.77 53.9659L134.312 53.0878L133.872 53.7949ZM131.855 54.7746L131.015 54.6901L125.996 62.6025C125.886 62.7762 125.94 63.0065 126.117 63.117C126.294 63.2274 126.526 63.1762 126.636 63.0025L131.855 54.7746Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M122.001 54.1733L133.178 54.8232L139.423 45.7078",
			stroke: "#CAD0E1",
			strokeWidth: .75,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .188509,
			y: .49161,
			width: 20.46,
			height: 11.1467,
			rx: .375,
			transform: "matrix(0.916296 0.400503 -0.413606 0.910456 159.673 107.024)",
			stroke: "#CAD0E1",
			strokeWidth: .75
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M167.809 117.171L173.609 125.535C173.726 125.704 173.961 125.746 174.133 125.628C174.305 125.51 174.349 125.278 174.232 125.109L168.646 117.053L167.809 117.171ZM165.634 116.221L165.164 115.531L155.322 116.844C155.116 116.871 154.969 117.059 154.995 117.263C155.021 117.467 155.209 117.611 155.416 117.583L165.634 116.221Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M159.502 108.115L166.416 117.368L178.054 116.223",
			stroke: "#CAD0E1",
			strokeWidth: .75,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.337 77.6592C86.0127 96.2987 101.082 110.855 110.532 115.803V117.118C84.7868 102.086 93.6751 84.5488 101.337 77.6592Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M102.295 76.5318C105.743 74.7781 113.252 70.6318 115.704 68.0764C111.937 68.2017 103.981 70.0681 102.295 76.5318Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.0387 83.2962C101.082 83.672 106.241 83.3337 110.532 78.9745C108.014 78.1603 102.19 77.8847 99.0387 83.2962Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.3569 94.1943C98.4002 93.5053 102.678 90.8872 103.445 85.9267C100.571 85.9894 95.1309 87.7306 96.3569 94.1943Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.0387 103.965C100.635 103.151 103.636 100.057 102.87 94.1943C100.124 94.8832 95.514 97.8019 99.0387 103.965Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.467 112.796C108.17 110.855 108.961 106.145 106.509 102.838C104.147 104.028 101.031 107.685 107.467 112.796Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.445 113.924C101.976 112.045 97.353 107.986 90.6101 106.783C92.0788 109.978 96.7017 115.878 103.445 113.924Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.2075 103.965C94.122 101.334 90.9166 95.8102 86.779 94.7579C86.339 97.8269 87.4088 103.965 95.2075 103.965Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M92.5258 93.6306C92.7173 90.3737 92.2959 83.5592 89.0777 82.3567C87.2898 85.1125 85.4764 91.2255 92.5258 93.6306Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.2075 82.3567C95.2075 82.3567 99.6134 78.035 97.1232 71.0828C94.4413 73.5505 90.3036 79.26 95.2075 82.3567Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M150.382 115.086C150.174 114.969 150.483 114.674 150.879 114.611L151.961 114.439C152.284 114.387 152.429 114.537 152.234 114.723L151.72 115.214C151.525 115.4 151.119 115.501 150.95 115.405L150.382 115.086Z",
			fill: "black",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .1875,
			y1: -.1875,
			x2: 4.61505,
			y2: -.1875,
			transform: "matrix(-0.709958 0.704244 -0.717808 -0.696242 170.942 74.465)",
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .1875,
			y1: -.1875,
			x2: 4.61505,
			y2: -.1875,
			transform: "matrix(-0.709958 0.704244 -0.717808 -0.696242 160.091 129.876)",
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5625,
			y1: -.5625,
			x2: 3.61172,
			y2: -.5625,
			transform: "matrix(0.713895 0.700253 -0.713895 0.700253 93.974 135.72)",
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5625,
			y1: -.5625,
			x2: 3.61172,
			y2: -.5625,
			transform: "matrix(0.713895 0.700253 -0.713895 0.700253 98.0377 139.706)",
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5625,
			y1: -.5625,
			x2: 3.61172,
			y2: -.5625,
			transform: "matrix(0.713895 -0.700253 0.713895 0.700253 95.0577 142.629)",
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5625,
			y1: -.5625,
			x2: 3.61172,
			y2: -.5625,
			transform: "matrix(0.713895 -0.700253 0.713895 0.700253 99.1212 138.643)",
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .1875,
			y1: -.1875,
			x2: 7.83496,
			y2: -.1875,
			transform: "matrix(-0.711541 0.702645 -0.71624 -0.697854 170.559 75.9681)",
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .1875,
			y1: -.1875,
			x2: 7.83496,
			y2: -.1875,
			transform: "matrix(-0.711541 0.702645 -0.71624 -0.697854 159.708 131.379)",
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.7094 56.4158C99.7094 56.4158 101.232 56.1749 101.88 55.5389C102.529 54.9029 102.774 53.4093 102.774 53.4093C102.774 53.4093 103.02 54.9029 103.668 55.5389C104.317 56.1749 105.839 56.4158 105.839 56.4158C105.839 56.4158 104.317 56.6567 103.668 57.2926C103.02 57.9286 102.774 59.4222 102.774 59.4222C102.774 59.4222 102.529 57.9286 101.88 57.2926C101.232 56.6567 99.7094 56.4158 99.7094 56.4158Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M165.617 59.0574C165.617 59.0574 167.14 58.8165 167.788 58.1805C168.436 57.5445 168.682 56.051 168.682 56.051C168.682 56.051 168.927 57.5445 169.576 58.1805C170.224 58.8165 171.747 59.0574 171.747 59.0574C171.747 59.0574 170.224 59.2983 169.576 59.9342C168.927 60.5702 168.682 62.0638 168.682 62.0638C168.682 62.0638 168.436 60.5702 167.788 59.9342C167.14 59.2983 165.617 59.0574 165.617 59.0574Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.961 137.974C116.961 137.974 118.484 137.734 119.132 137.098C119.78 136.462 120.026 134.968 120.026 134.968C120.026 134.968 120.272 136.462 120.92 137.098C121.568 137.734 123.091 137.974 123.091 137.974C123.091 137.974 121.568 138.215 120.92 138.851C120.272 139.487 120.026 140.981 120.026 140.981C120.026 140.981 119.78 139.487 119.132 138.851C118.484 138.215 116.961 137.974 116.961 137.974Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_1075_751)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M107.255 63.1638C107.255 62.0593 108.151 61.1638 109.255 61.1638H149.694C150.22 61.1638 150.726 61.3715 151.1 61.7418L154.351 64.957L157.745 68.3206C158.124 68.6962 158.338 69.2076 158.338 69.7412V123.016C158.338 124.12 157.442 125.016 156.338 125.016H109.255C108.151 125.016 107.255 124.12 107.255 123.016V63.1638Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 125.417,
			y1: 94.9423,
			x2: 149.058,
			y2: 94.9423,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 125.417,
			y1: 113.463,
			x2: 143.479,
			y2: 113.463,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 125.417,
			y1: 91.5012,
			x2: 149.058,
			y2: 91.5012,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .75,
			y1: -.75,
			x2: 23.2222,
			y2: -.75,
			transform: "matrix(0.99998 0.00636641 -0.00661686 0.999978 124.667 110.451)",
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 125.417,
			y1: 98.3832,
			x2: 140.873,
			y2: 98.3832,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 125.417,
			y1: 117.309,
			x2: 145.55,
			y2: 117.309,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 117.711,
			y1: 70.8248,
			x2: 129.946,
			y2: 70.8248,
			stroke: "#031A6B",
			strokeOpacity: .5,
			strokeWidth: 2.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 117.211,
			y1: 76.2024,
			x2: 149.081,
			y2: 76.2024,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 117.211,
			y1: 79.6019,
			x2: 134.779,
			y2: 79.6019,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_d_1075_751)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M150.598 68.6885L158.269 69.0647L150.214 61.1638L150.598 68.6885Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 117.213,
			y: 88.9534,
			width: 4.38506,
			height: 4.30127,
			rx: 1.5,
			fill: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1075_751",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 116,
			y: 88,
			width: 7,
			height: 6,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M116.482 88.2366H122.328V93.9716H116.482V88.2366Z",
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_1075_751)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M119.046 92.0719L120.787 90.3574L120.501 90.0765L119.046 91.5044L118.327 90.8055L118.041 91.0862L119.046 92.0719Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M119.046 92.0719L120.787 90.3574L120.501 90.0765L119.046 91.5044L118.327 90.8055L118.041 91.0862L119.046 92.0719Z",
				fill: "white"
			})]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 117.213,
			y: 106.732,
			width: 4.38506,
			height: 4.30127,
			rx: 1.5,
			fill: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_1075_751",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 116,
			y: 106,
			width: 7,
			height: 6,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M116.482 106.015H122.328V111.75H116.482V106.015Z",
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask1_1075_751)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M119.046 109.851L120.787 108.136L120.501 107.855L119.046 109.283L118.327 108.584L118.041 108.865L119.046 109.851Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M119.046 109.851L120.787 108.136L120.501 107.855L119.046 109.283L118.327 108.584L118.041 108.865L119.046 109.851Z",
				fill: "white"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.082 110.05C136.844 110.172 136.558 110.018 136.535 109.755L136.366 107.82C136.34 107.523 136.661 107.315 136.925 107.458L138.85 108.496C139.115 108.638 139.108 109.015 138.838 109.153L137.082 110.05Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 3.59635,
			height: 25.8053,
			rx: .75,
			transform: "matrix(0.880217 0.474572 -0.488845 0.87237 148.702 85)",
			fill: "#FFB484"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.89 85.6396L151.208 86.3504C151.572 86.547 151.704 86.9993 151.501 87.3606L139.62 108.564C139.417 108.925 138.958 109.059 138.593 108.862L138.462 108.791L149.89 85.6396Z",
			fill: "#F29559"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_1075_751",
			x: 104.755,
			y: 61.1638,
			width: 56.0823,
			height: 71.3521,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 5 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.25 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.614167 0 0 0 0 0.614167 0 0 0 0 0.733333 0 0 0 0.15 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_1075_751"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_1075_751",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "filter1_d_1075_751",
			x: 148.714,
			y: 60.6638,
			width: 11.0548,
			height: 10.9009,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .75 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.832587 0 0 0 0 0.851891 0 0 0 0 0.920833 0 0 0 0.5 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_1075_751"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_1075_751",
					result: "shape"
				})
			]
		})] })
	]
});
const ForwardRef = forwardRef(SvgPhaseTwo);
export { ForwardRef as ReactComponent };
